import * as React from 'react'
import * as Container from "../../container/container";

const Video = (key) => {
    return (
        <Container.Part background="beige" id="trailer" key={key}>
            <Container.Row>
                <div className="col-12">
                    <div className="inner-container">
                        <h2>Auf ein Gespräch mit Oberbürgermeister Andreas Starke im Bamberger Spiegelsaal der
                            Harmonie.</h2>
                        <figure className="video">
                            <div className="yt-container yt-enabled">
                                <Container.Video url={"/videos/Filmmaterial/005_Bamberg/211011_Bamberg.mp4"}
                                                 poster={"/images/Videowallpaper/bamberg.jpg"}/>
                            </div>
                        </figure>
                    </div>
                </div>
            </Container.Row>
        </Container.Part>
    )
}

export default Video
